export default __webpack_public_path__ + "static/upwaltham_2-966158823ce9cdb6f3807fd44236f05e.jpg";